import { userInfoAtom } from 'app/atoms';
import { useNavigation } from 'app/hooks/navigation';
import { useAllGroups } from 'app/network/groups';
import type * as profile from 'app/screens/profile/navigator';
import type * as root from 'app/screens/root-stack';
import { useAtomValue } from 'jotai';

import { useProfileSections } from 'app/hooks/use-profil-sections';
import { useTranslation } from 'react-i18next';
import ProfileSection from './profile-sections';

export function ProfileLinks() {
  const navigation = useNavigation<'profile-overview'>();

  const { t } = useTranslation('profile-overview');
  const userInfo = useAtomValue(userInfoAtom);
  const { data: groups } = useAllGroups();

  const navigate = (route: keyof root.Parameters | keyof profile.Parameters, screen?: string, params?: object) =>
    // @ts-expect-error tuple union thing?
    navigation.navigate(route, { screen, ...(params || {}) });

  const { sections } = useProfileSections({
    userInfo,
    navigate,
    t,
    groups,
  });

  return sections.map((section) => {
    return 'title' in section ? <ProfileSection key={section.title} {...section} /> : section;
  });
}
